import script from "./FlashMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashMessages.vue?vue&type=script&setup=true&lang=js"

import "./FlashMessages.vue?vue&type=style&index=0&id=57047f7d&scoped=true&lang=css"
script.__scopeId = "data-v-57047f7d"

export default script